import type { Policy, PolicyType } from '../types/policy';

/**
 * G-1 정책 단일활성 보장 (FE 게이트).
 *
 * BE 의 `isActive` 는 멀티행 독립이라 신규 정책을 활성으로 생성해도 같은 type 의 기존
 * 활성 정책이 자동으로 꺼지지 않아 "2개 활성" 이 된다. BO 는 신규 생성(isActive=true) 시
 * 같은 type 에 이미 활성 정책이 있으면 모달로 의사를 묻고, "예" 면 기존 활성 정책을
 * 비활성화한 뒤 생성한다(단일활성). "아니오" 면 그대로 생성(2개 활성 = 사용자 명시 허용).
 *
 * 이 모듈은 그 판정 + 비활성화 대상 선별을 순수 함수로 분리해 회귀 테스트 가능하게 한다.
 */

export interface NewPolicyIntent {
  isNew: boolean;
  isActive: boolean;
  type: PolicyType;
}

/**
 * 신규 활성 정책 생성이 기존 활성 정책과 충돌해 단일활성 모달이 필요한지.
 * - 신규(isNew) + 활성(isActive) + 같은 type 의 기존 활성 정책 ≥ 1 → true.
 */
export const needsSingleActiveConfirm = (
  intent: NewPolicyIntent,
  activePoliciesSameType: ReadonlyArray<Policy>,
): boolean =>
  intent.isNew && intent.isActive && activePoliciesSameType.length > 0;

/**
 * "예"(단일활성) 선택 시 비활성화할 기존 활성 정책 목록.
 * 방어적으로 같은 type & isActive 인 정책만 추린다(쿼리가 type 미스매치로 섞여 와도 안전).
 */
export const policiesToDeactivate = (
  type: PolicyType,
  activePolicies: ReadonlyArray<Policy>,
): ReadonlyArray<Policy> =>
  activePolicies.filter((p) => p.type === type && p.isActive);
